import { useDrag } from '../../../hooks/drag';
import { useSingleton, useUpdate } from '@bydesign-ui/hooks';
import { useCallback, useEffect } from 'react';
import { useElementPosition } from '@bydesign-ui/hooks';
import { ScheduleMask } from '../../../models/schedule';
import { useSchedule } from './useSchedule';
export function useScheduleMask(elem, name, draggable) {
  var schedule = useSchedule();
  var mask = useSingleton(function () {
    return new ScheduleMask(schedule);
  });
  var update = useUpdate();
  var onDragStart = useCallback(function (e) {
    mask.updateStartPos(e.startMousePos);
  }, []);
  var onDragging = useCallback(function (e) {
    mask.updateEndPos(e.currentMousePos);
  }, []);
  var onDragEnd = useCallback(function (e) {
    mask.stopDrag(e.currentMousePos);
  }, []);
  var updateColSize = useCallback(function () {
    mask.updateColSize();
  }, []);
  useDrag(elem, {
    draggable: draggable,
    data: null,
    onDragEnd: onDragEnd,
    onDragging: onDragging,
    onDragStart: onDragStart
  });
  useElementPosition(elem, function () {
    return true;
  }, function (rect) {
    mask.updateBoxRect(rect);
  }, {});
  useEffect(function () {
    mask.addListener('repaint', update);
    schedule.addListener('datasource-update', updateColSize);
    return function () {
      mask.removeListener('repaint', update);
      schedule.removeListener('datasource-update', updateColSize);
    };
  }, []);
  return {
    maskRelativeRect: mask.getMaskRelativeRect(),
    dragging: mask.getDragging()
  };
}